import { useEffect, useRef } from "react";
import Lenis from "lenis";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { createLenis, bindKeyboardScrollFix } from "./lenis";

gsap.registerPlugin(ScrollTrigger);

/**
 * Sets up Lenis smooth-scroll + GSAP ScrollTrigger for the page.
 *
 * `enabled` lets the caller opt out: premium layouts (e.g. Onyx) own their own
 * Lenis instance, so JoinPage must NOT also spin one up — two Lenis engines on
 * one page fight each other, and this hook's cleanup calls `ScrollTrigger.killAll()`
 * which would nuke the layout's own triggers. Pass `false` for those layouts.
 */
export function useScrollSetup(enabled = true) {
  const lenisRef = useRef<Lenis | null>(null);

  useEffect(() => {
    if (!enabled) return;

    const lenis = createLenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    lenisRef.current = lenis;

    // Feed Lenis RAF into GSAP ticker so ScrollTrigger stays in sync
    const ticker = (time: number) => lenis.raf(time * 1000);
    gsap.ticker.add(ticker);
    gsap.ticker.lagSmoothing(0);

    lenis.on("scroll", ScrollTrigger.update);
    // Klavye ↔ smooth-scroll çekişmesini önle (RSVP formu odak bug'ı).
    const detachKeyboardFix = bindKeyboardScrollFix(lenis);

    return () => {
      detachKeyboardFix();
      lenis.destroy();
      gsap.ticker.remove(ticker);
      ScrollTrigger.killAll();
    };
  }, [enabled]);

  return lenisRef;
}
